import { render } from "./Rankings.vue?vue&type=template&id=59cb39e4&scoped=true"
import script from "./Rankings.vue?vue&type=script&lang=js"
export * from "./Rankings.vue?vue&type=script&lang=js"

import "./Rankings.vue?vue&type=style&index=0&id=59cb39e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59cb39e4"]])

export default __exports__